import React, { useEffect } from 'react';
import { useState, useMemo } from 'react';
import { Form, Button, Spinner, Col, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion } from "react-bootstrap";
import { FaAngleDoubleDown } from 'react-icons/fa';
import { CategoryTargetImsVW} from '../Redux/MapAction';
import LoadingSpinner from '../../modules/Billing/Components/LoadingSpinner';
import DownloadDropdown from "../../modules/master/PrintDwopdown/ExcelDawnload";


import { RHFInput } from "react-hook-form-input";
import Select from "react-select";

import {
  getAreaListByDivisionEntry,
  getDivisionListByZoneEntry,
  getTerritoryEntry,
  getZoneListEntry,
} from "../../../src/modules/Cfo/DistributorReportAction";






const CategoryTargetIms = () => {

    const dispatch = useDispatch();
    // const { register, setValue } = useForm();
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const handleAccordionToggle = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };
    
    const currentDate = new Date();
    const fullDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`;

    const [startDate, setStartDate] = useState(fullDate);
    const [toDate, setToDate] = useState(fullDate);


    const { register, handleSubmit, errors, setFocus, setValue } = useForm();



    const [zone, Setzone] = useState([]);
    const [division, SetDivision] = useState([]);
    const [selectZone, setSelectZone] = useState(1);
    const [area, setArea] = useState([]);
    const [selectDivision, setSelectDivision] = useState(24);
    const [selectArea, setSelectArea] = useState(142);
    const [selectGeoType, setSelectGeoType] = useState(2);
    const [terriory, setTerritory] = useState([]);
    const [selectTerritory, setSelectTerritory] = useState(0);



    const divisionList = async (id) => {
        let divisionData = await getDivisionListByZoneEntry(id, selectGeoType);
        SetDivision(divisionData.data);
    };
    const getAreaData = async (id) => {
        let areaData = await getAreaListByDivisionEntry(id, selectGeoType);
        setArea(areaData.data);
    };
    const getTerritoryData = async (id) => {
        let territoryData = await getTerritoryEntry(id, selectGeoType);
        setTerritory(territoryData.data);
    }; 
    
    const zoneDropdownData = () => {
        let options = [];
        if (zone?.length > 0) {
        zone.forEach((item) => {
            let itemData = {
            value: item.zoneID,
            label: item.zoneName,
            };

            options.push(itemData);
        });
        }
        // setValue("divisionData", "");

        return options;
    };
    const divisionDropdownData = () => {
        let options = [];
        if (division?.length > 0) {
        division.forEach((item) => {
            let itemData = {
            value: item.divisionID,
            label: item.divisionName,
            };

            options.push(itemData);
        });
        }
        return options;
    };
    const areaDropdownData = () => {
        let options = [];
        if (area?.length > 0) {
        area.forEach((item) => {
            let itemData = {
            value: item.areaID,
            label: item.areaName,
            };

            options.push(itemData);
        });
        }
        return options;
    };
    const territoryDropdownData = () => {
        let options = [];
        if (terriory?.length > 0) {
        terriory.forEach((item) => {
            let itemData = {
            value: item.territoryId,
            label: item.territoryName,
            };

            options.push(itemData);
        });
        }
        return options;
    };


    const handleChangeStartDate = ({ currentTarget: input }) => {
        setStartDate(input.value);
    };

    const handleChangeTodate = ({ currentTarget: input }) => {
        setToDate(input.value);
    };

    const handleSummeryReport = async () => {
        dispatch(
            CategoryTargetImsVW(
                startDate, 
                toDate,
                selectZone,
                selectDivision,
                selectArea,
                selectTerritory,
            )
        )
    }    

    useEffect(() => {      
        initialData();
        
    }, [dispatch])

    const initialData = async () => {


        let zoneData = await getZoneListEntry();        
        Setzone(zoneData.data);

        await dispatch(
            CategoryTargetImsVW(
                startDate, 
                toDate,
                selectZone,
                selectDivision,
                selectArea,
                selectTerritory,
            )
        )        

    }
    const categoryTargetImsDataViews = useSelector(state => state?.mapData?.categoryTargetImsDataView?.allData);
    const categoryTargetImsDataViewIsLoading = useSelector(state => state?.mapData?.categoryTargetImsDataViewIsLoading);

    const uniqueOptions = (key) => {
    const all = categoryTargetImsDataViews?.map((item) => {
        if (key === 'targetMonth') {
        const d = new Date(item[key]);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; // format: 2025-04
        }
        return item[key];
    });

    return [...new Set(all)].filter(Boolean);
    };

    

    const getCategoryBgColor = (value) => {
    if (value < 999999) return '#ffffff';
    else return '#ffbf00';
    };

    
    
    const inputDate = new Date(startDate);
    const currMonthLabel = inputDate.toLocaleString('en-US', {
    month: 'short',
    year: 'numeric'
    });

    const displayedCategories = new Set();   

    // Group By Territory
    const groupedByTerritory = useMemo(() => {
    if (!Array.isArray(categoryTargetImsDataViews)) {
        console.warn("categoryTargetImsDataViews is not ready");
        return [];
    }

    const matched = categoryTargetImsDataViews.filter((item) => {

        const matchesZone = !selectZone || item.zoneId === Number(selectZone);
        const matchesDivision = !selectDivision || item.divisionId === Number(selectDivision);
        const matchesArea = !selectArea || item.areaId === Number(selectArea);
        // const matchesMonth = (!filters.targetMonth || new Date(item.targetMonth).toISOString().slice(0, 7) === filters.targetMonth)

        // return matchesArea && matchesMonth;
        return matchesZone && matchesDivision && matchesArea;;
    });

    const grouped = {};

    matched.forEach((item) => {
        const territoryId = item.territoryId;
        const monthKey = new Date(item.targetMonth).toISOString().slice(0, 7);
        const key = `${item.prodCatId}-${monthKey}`;

        if (!grouped[territoryId]) {
        grouped[territoryId] = {
            territoryName: item.territoryName,
            rows: {},
        };
        }

        if (!grouped[territoryId].rows[key]) {
        grouped[territoryId].rows[key] = {
            prodCatId: item.prodCatId,
            productCategoryName: item.productCategoryName,
            areaName: item.areaName,
            targetMonth: monthKey,
            targetAmount: 0,
            lastMonthIMS: 0,
            totalIMSCurrentMonth: 0,
            achievementPercent: 0,
            imsGrowthPercent: 0,
            count: 0,
        };
        }

        const group = grouped[territoryId].rows[key];
       
        group.targetAmount = item.targetAmount;
        group.lastMonthIMS = item.lastMonthIMS;
        group.totalIMSCurrentMonth = item.totalIMSCurrentMonth;
        group.achievementPercent = item.achievementPercent;
        group.imsGrowthPercent = item.imsGrowthPercent;
        group.count = 1;
    });

    return Object.entries(grouped).map(([territoryId, group]) => ({
        territoryId,
        territoryName: group.territoryName,
        rows: Object.values(group.rows).map((g) => ({
        ...g,
        achievementPercent: Math.round(g.achievementPercent / g.count),
        imsGrowthPercent: Math.round(g.imsGrowthPercent / g.count),
        })),
    }));
    }, [categoryTargetImsDataViews, selectArea]);


    const areaName = groupedByTerritory?.[0]?.rows?.[0]?.areaName || "Area";


    return (
        <div className='container ims-division-wise-report'>

            <div className=' container-fluid top_card3-map rounded mb-5'>
                <Accordion activeKey={isAccordionOpen ? "1" : "0"}>

                    <Accordion.Toggle as={Button} variant="link" eventKey="1" className="arrayButton" onClick={handleAccordionToggle}>
                        <div>
                            <div className="dailysales text-center dailysalesmargin dailysalesfont row  ">
                                <span className="sales-title-map" style={{ width: '400px', margin: 'auto' }} >Category Wise Target Ims
                                    <div>
                                        <FaAngleDoubleDown className="float-right toparrow blink-text dropdownArrow" />
                                        <span className="clickHere float-right">
                                            {isAccordionOpen ? "Click to Close" : "Click to Expand"}
                                        </span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1" onEnter={() => setIsAccordionOpen(true)} onExit={() => setIsAccordionOpen(false)}>
                        <div>

                              
                            <div className="justify-content-center bg-blue ">  


                                <div className='form-group row'>
                                    <div className="col-lg-2">
                                        <Form.Group as={Col} controlId="formGridState">
                                        <label className="form-label">From Date</label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Enter Deadweight"
                                            name="fromDate"
                                            value={startDate}
                                            className="form-control cusheight"
                                            onChange={handleChangeStartDate}
                                        />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-2">
                                        <Form.Group as={Col} controlId="formGridState">
                                        <label className="form-label"> To Date</label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Enter Todate"
                                            name="todate"
                                            value={toDate}
                                            className="form-control cusheight"
                                            onChange={handleChangeTodate}
                                        />
                                        </Form.Group>
                                    </div>
                                    
                                    
                                    <div className="col-lg-2">
                                        <Form.Group as={Col} controlId="formGridState">
                                        <label className="form-label">Select Zones</label>
                                        <RHFInput
                                            className="formSelect pt-0"
                                            as={<Select options={zoneDropdownData()} />}
                                            rules={{ required: false }}
                                            name="zoneData"
                                            register={register}
                                            // value={selectZone}
                                            value=""
                                            isClearable
                                            onChange={(option) => {
                                            divisionList(option?.value);
                                            setSelectZone(option?.value);                                           
                                            setValue("divisionData", "");
                                            setValue("areaData", "");
                                            setValue("territory", "");
                                            setValue("distributor", "");
                                            // setFilters("zoneId", option?.value)
                                            }}
                                            setValue={setValue}
                                        />
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-2">
                                    <Form.Group as={Col} controlId="formGridState">
                                    <label className="form-label">Select Division</label>
                                    <RHFInput
                                        className="formSelect pt-0"
                                        as={<Select options={divisionDropdownData()} />}
                                        rules={{ required: false }}
                                        name="divisionData"
                                        register={register}
                                        value=""
                                        isClearable
                                        // value={CertificateMasterInput.isActive}
                                        onChange={(option) => {
                                        // setType(option.value)
                                        getAreaData(option?.value);
                                        setSelectDivision(option?.value);                                        
                                        setValue("areaData", "");
                                        setValue("territory", "");
                                        // setFilters("divisionId", option?.value)
                                        }}
                                        setValue={setValue}
                                    />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-2">
                                    <Form.Group as={Col} controlId="formGridState">
                                    <label className="form-label">Select Region</label>
                                    <RHFInput
                                        className="formSelect pt-0"
                                        as={<Select options={areaDropdownData()} />}
                                        rules={{ required: false }}
                                        name="areaData"
                                        register={register}
                                        value=""
                                        isClearable
                                        // value={CertificateMasterInput.isActive}
                                        onChange={(option) => {
                                        // setType(option.value)
                                        getTerritoryData(option?.value);
                                        setSelectArea(option?.value);                                        
                                        setValue("territory", "");                                        
                                        // setFilters("areaId", option?.value)
                                        // setFilters("territoryId", "")
                                        
                                        }}
                                        setValue={setValue}
                                    />
                                    </Form.Group>
                                </div>
                                {/* <div className="col-lg-2">
                                    <Form.Group as={Col} controlId="formGridState">
                                    <label className="form-label">Select Territory</label>
                                    <RHFInput
                                        className="formSelect pt-0"
                                        as={<Select options={territoryDropdownData()} />}
                                        rules={{ required: false }}
                                        name="territory"
                                        register={register}
                                        value=""
                                        isClearable
                                        // value={CertificateMasterInput.isActive}
                                        onChange={(option) => {
                                        setSelectTerritory(option?.value);                                        
                                        }}
                                        setValue={setValue}
                                    />
                                    </Form.Group>
                                </div> */}
                                <div className="col-lg-2 mt-2 py-4">
                                     {toDate !== null ? (
                                            <button className="btn btn-primary btn-sm " onClick={() => handleSummeryReport()}>Filter</button>
                                            ) : null}           
                                </div>
                            </div>                  
                                                              
                            </div>
                        </div>
                    </Accordion.Collapse>
                </Accordion>
            </div>           
            {
                categoryTargetImsDataViewIsLoading &&
                <LoadingSpinner />

            }

             {!categoryTargetImsDataViewIsLoading && <>
                <p className='export-for-excel'>
                    <DownloadDropdown excelname='Category Wise Target Ims Report' />
                </p>
                {categoryTargetImsDataViews?.length <= 0 ? <p className='noAvailableata'>No Available data here</p> :

                    <div className="table-responsive" style={{ maxHeight: '500px' }}>

                        {selectArea && (
                        <div className="my-4">                            
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                <table id="table-to-xls">
                                    <tr> 
                                        <td>
                                            <table>
                                                <tr>
                                                   <td className="">
                                                        <h4 className="text-lg font-bold">Category</h4>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ minWidth: '250px' }}>
                                                         <table className="table table-bordered table-sm text-center">
                                                            <thead className="text-xs uppercase text-gray-700">
                                                                <tr>
                                                                    <td className="mb-6 border bg-category-list text-center">                                                                  
                                                                        Category
                                                                    </td>                                                                    
                                                                </tr>
                                                            </thead>
                                                            <tbody className="text-left">                                                               
                                                                 {categoryTargetImsDataViews?.map((row, index) => {
                                                                const isFirstOccurrence = !displayedCategories.has(row.prodCatId);
                                                                if (isFirstOccurrence) {
                                                                    displayedCategories.add(row.prodCatId);
                                                                }

                                                                return (
                                                                    <tr key={index} className="">
                                                                         {isFirstOccurrence ?
                                                                    <td className="px-1  border" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                                        {row.productCategoryName}
                                                                    </td>
                                                                    : ''}
                                                                    </tr>
                                                                );
                                                                })}

                                                                <tr>
                                                                    <td className="px-1  border" style={{backgroundColor:'#00b0f0'}}>                                                                  
                                                                        Total
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            
                                                        </table>

                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        
                                      {groupedByTerritory.map((territory) => {                                         
                                            const validRows = territory.rows.filter(row => row.prodCatId !== 999999);                                       
                                            const totals = validRows.reduce(
                                                (acc, row) => {
                                                acc.targetAmount += row.targetAmount || 0;
                                                acc.lastMonthIMS += row.lastMonthIMS || 0;
                                                acc.totalIMSCurrentMonth += row.totalIMSCurrentMonth || 0;
                                                acc.achievementPercent += row.achievementPercent || 0;
                                                acc.imsGrowthPercent += row.imsGrowthPercent || 0;
                                                return acc;
                                                },
                                                {
                                                targetAmount: 0,
                                                lastMonthIMS: 0,
                                                totalIMSCurrentMonth: 0,
                                                achievementPercent: 0,
                                                imsGrowthPercent: 0,
                                                }
                                            );

                                            const validCount = validRows.length || 1;
                                            // const avgAchPercent = (totals.achievementPercent / validCount).toFixed(1);
                                            // const avgGrowthPercent = (totals.imsGrowthPercent / validCount).toFixed(1);

                                            const avgAchPercent = totals.targetAmount === 0  ? 0 : ((totals.totalIMSCurrentMonth / totals.targetAmount) * 100).toFixed(1);
                                            const avgGrowthPercent = totals.lastMonthIMS === 0  ? 0 : (((totals.totalIMSCurrentMonth / totals.lastMonthIMS) -1) * 100).toFixed(1);


                                            
                                            // const achievementPercent = row.targetAmount === 0  ? 0 : ((row.totalIMSCurrentMonth / row.targetAmount) * 100).toFixed(1);
                                            // const imsGrowthPercent = row.lastMonthIMS === 0  ? 0 : (((row.totalIMSCurrentMonth / row.lastMonthIMS) -1) * 100).toFixed(1);

                                           
                                          return (
                                            <td key={territory.territoryId} className="mb-6">
                                                <h4 className="text-lg font-bold mb-2">
                                                    {territory.territoryName.length > 12 ? territory.territoryName.slice(0, 12) + '...' : territory.territoryName} territory
                                                </h4>

                                                <table className="table table-bordered table-sm text-center w-full" id="table-to-xls">
                                                <thead className="text-xs uppercase text-gray-700">
                                                    <tr>
                                                    <th className="px-1  border bg-target-curr text-center" style={{ verticalAlign: 'middle' }}>
                                                        Target<br /><small>{currMonthLabel}</small>
                                                    </th>
                                                    <th className="px-1  border bg-ims-curr text-center" style={{ verticalAlign: 'middle' }}>
                                                        IMS<br /><small>{currMonthLabel}</small>
                                                    </th>
                                                    <th className="px-1  border bg-ach-perc text-center" style={{ verticalAlign: 'middle' }}>
                                                        Ach %
                                                    </th>
                                                    <th className="px-1  border bg-growth-perc text-center" style={{ verticalAlign: 'middle' }}>
                                                        Growth %
                                                    </th>
                                                    </tr>
                                                </thead>

                                                <tbody className="text-left">
                                                    {/* {territory.rows.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                        {row.targetAmount.toLocaleString()}
                                                        </td>
                                                        <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                        {row.totalIMSCurrentMonth.toLocaleString()}
                                                        </td>
                                                        <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId)}}>
                                                            <span style={{ color: parseInt(row.achievementPercent) < 100 ? '#ff052f' : 'inherit' }}>
                                                                {row.achievementPercent}%
                                                            </span>
                                                        </td>
                                                        <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                        {row.imsGrowthPercent}%
                                                        </td>
                                                    </tr>
                                                    ))} */}

                                                    {territory.rows.map((row, idx) => {                                                        
                                                        const achievementPercent = row.targetAmount === 0
                                                            ? 0
                                                            : ((row.totalIMSCurrentMonth / row.targetAmount) * 100).toFixed(1);
                                                        
                                                        const imsGrowthPercent = row.lastMonthIMS === 0
                                                            ? 0
                                                            : (((row.totalIMSCurrentMonth / row.lastMonthIMS) - 1) * 100).toFixed(1);

                                                        return (
                                                            <tr key={idx}>
                                                                <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                                    {row.targetAmount.toLocaleString()}
                                                                </td>
                                                                <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                                    {row.totalIMSCurrentMonth.toLocaleString()}
                                                                </td>
                                                                <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                                    <span style={{ color: parseFloat(achievementPercent) < 100 ? '#ff052f' : 'inherit' }}>
                                                                        {achievementPercent}%
                                                                    </span>
                                                                </td>
                                                                <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(row.prodCatId) }}>
                                                                    {imsGrowthPercent}%
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}

                                                 
                                                    <tr className="font-bold bg-blue" style={{backgroundColor:'#00b0f0'}}>
                                                        <td className="px-1 border text-right">{totals.targetAmount.toLocaleString()}</td>
                                                        <td className="px-1 border text-right">{totals.totalIMSCurrentMonth.toLocaleString()}</td>
                                                        <td className="px-1 border text-right">{avgAchPercent}%</td>
                                                        <td className="px-1 border text-right">{avgGrowthPercent}%</td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </td>
                                            )                                            
                                        })} 

                                        {/* Area-wise Category Breakdown Table */}
                                        <td className="mb-6">
                                        <h4 className="text-lg font-bold mb-2" style={{ backgroundColor: '#ffe699' }}>
                                            {areaName.length > 12 ? areaName.slice(0, 12) + '...' : areaName} region                                            
                                        </h4>
                                        {(() => {
                                            // Get all rows across all territories
                                            const allRows = groupedByTerritory.flatMap(t => t.rows).filter(row => row.prodCatId !== 9999999);

                                            // Group rows by prodCatId
                                            const categoryMap = new Map();

                                            allRows.forEach(row => {
                                            if (!categoryMap.has(row.prodCatId)) {
                                                categoryMap.set(row.prodCatId, {
                                                prodCatId: row.prodCatId,
                                                prodCatName: row.prodCatName,
                                                targetAmount: 0,
                                                lastMonthIMS: 0,
                                                totalIMSCurrentMonth: 0,
                                                achievementPercent: 0,
                                                imsGrowthPercent: 0,
                                                count: 0,
                                                });
                                            }

                                            const cat = categoryMap.get(row.prodCatId);
                                            cat.targetAmount += row.targetAmount || 0;
                                            cat.lastMonthIMS += row.lastMonthIMS || 0;
                                            cat.totalIMSCurrentMonth += row.totalIMSCurrentMonth || 0;
                                            cat.achievementPercent += row.achievementPercent || 0;
                                            cat.imsGrowthPercent += row.imsGrowthPercent || 0;
                                            cat.count += 1;
                                            });

                                            const categoryList = Array.from(categoryMap.values());

                                            // Area grand total
                                            const areaTotal = categoryList.reduce(
                                            (acc, cat) => {
                                                acc.targetAmount += cat.targetAmount;
                                                acc.lastMonthIMS += cat.lastMonthIMS;
                                                acc.totalIMSCurrentMonth += cat.totalIMSCurrentMonth;
                                                acc.achievementPercent += cat.achievementPercent;
                                                acc.imsGrowthPercent += cat.imsGrowthPercent;
                                                acc.count += 1;
                                                return acc;
                                            },
                                            {
                                                targetAmount: 0,
                                                lastMonthIMS: 0,
                                                totalIMSCurrentMonth: 0,
                                                achievementPercent: 0,
                                                imsGrowthPercent: 0,
                                                count: 0,
                                            }
                                            );

                                            //const avgAch = (areaTotal.achievementPercent / areaTotal.count).toFixed(1);
                                            //const avgGrowth = (areaTotal.imsGrowthPercent / areaTotal.count).toFixed(1);

                                            const avgAch = areaTotal.targetAmount === 0  ? 0 : ((areaTotal.totalIMSCurrentMonth / areaTotal.targetAmount) * 100).toFixed(1);
                                            const avgGrowth = areaTotal.lastMonthIMS === 0  ? 0 : (((areaTotal.totalIMSCurrentMonth / areaTotal.lastMonthIMS) -1) * 100).toFixed(1);

                                            return (
                                            <table className="table table-bordered table-sm text-center w-full" id="table-to-xls">
                                                <thead className="text-xs uppercase text-gray-700 sticky-top">
                                                <tr>
                                                    <th className="px-1 border bg-target-curr">Target<br /><small>{currMonthLabel}</small></th>
                                                    <th className="px-1 border bg-ims-curr">IMS<br /><small>{currMonthLabel}</small></th>
                                                    <th className="px-1 border bg-ach-perc">Ach %</th>
                                                    <th className="px-1 border bg-growth-perc">Growth %</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {/* {categoryList.map((cat, idx) => (
                                                    <tr key={idx}>                                                    
                                                    <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>{cat.targetAmount.toLocaleString()}</td>
                                                    <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>{cat.totalIMSCurrentMonth.toLocaleString()}</td>
                                                    <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>{(cat.achievementPercent / cat.count).toFixed(1)}%</td>
                                                    <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>{(cat.imsGrowthPercent / cat.count).toFixed(1)}%</td>
                                                    </tr>
                                                ))} */}

                                                {categoryList.map((cat, idx) => {
                                                    const achievementPercent = cat.targetAmount === 0
                                                        ? 0
                                                        : ((cat.totalIMSCurrentMonth / cat.targetAmount) * 100).toFixed(1);

                                                    const imsGrowthPercent = cat.lastMonthIMS === 0
                                                        ? 0
                                                        : (((cat.totalIMSCurrentMonth / cat.lastMonthIMS) - 1) * 100).toFixed(1);

                                                    return (
                                                        <tr key={idx}>
                                                            <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>
                                                                {cat.targetAmount.toLocaleString()}
                                                            </td>
                                                            <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>
                                                                {cat.totalIMSCurrentMonth.toLocaleString()}
                                                            </td>
                                                            <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>
                                                                <span style={{ color: parseFloat(achievementPercent) < 100 ? '#ff052f' : 'inherit' }}>
                                                                    {achievementPercent}%
                                                                </span>
                                                            </td>
                                                            <td className="px-1 border text-right" style={{ backgroundColor: getCategoryBgColor(cat.prodCatId) }}>
                                                                {imsGrowthPercent}%
                                                            </td>
                                                        </tr>
                                                    );
                                                })}


                                                {/* Grand total row */}
                                                <tr className="font-bold" style={{ backgroundColor: '#00b0f0' }}>                                                   
                                                    <td className="px-1 border text-right">{areaTotal.targetAmount.toLocaleString()}</td>                                                   
                                                    <td className="px-1 border text-right">{areaTotal.totalIMSCurrentMonth.toLocaleString()}</td>
                                                    <td className="px-1 border text-right">{avgAch}%</td>
                                                    <td className="px-1 border text-right">{avgGrowth}%</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            );
                                        })()}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        )}  
                        
                    </div>
                }
            </>

            }
            
        </div>
    );
};

export default CategoryTargetIms;